module.exports = __webpack_public_path__ + "fonts/HelveticaNeueCyrRoman.9ea7658.eot";